// React
import React, { useEffect } from "react";
// Utils
import api from "api/config";
import { ELEMENTS_IDS } from "constants/ElementsIds";
import {
  ADDRESS_BOOK,
  BUSINESS_SETTINGS,
  EMAIL_SETTINGS,
  MANAGEMENT_SETTINGS,
  SECURITY_SETTINGS,
  SETTINGS,
  SIRES,
  SUPPLIER_MANAGEMENT,
  USER_SETTINGS,
  BANK_DETAILS,
} from "constants/Routes";

// Hooks
import { useEventRequest, useGetBusinessUnitUserRole, useHasFeature } from "hooks";
// Components
import { PageMenu, PageMenuLink } from "components";

interface SettingsMenuProps {
  farmer: boolean;
}
export const SettingsMenu: React.FC<SettingsMenuProps> = ({ farmer }) => {
  const { eventsRequest } = useEventRequest();
  const { isAdmin, isManager } = useGetBusinessUnitUserRole();

  type SubMenuLink = {
    caption: string;
    path: string;
    visible?: boolean;
  };

  const subMenuItems: SubMenuLink[] = [
    {
      caption: "My settings",
      path: `${SETTINGS}${USER_SETTINGS}`,
    },
    {
      caption: "Email settings",
      path: `${SETTINGS}${EMAIL_SETTINGS}`,
    },
    {
      caption: "Security settings",
      path: `${SETTINGS}${SECURITY_SETTINGS}`,
    },
    {
      caption: "Sire information",
      path: SIRES,
      visible: farmer && useHasFeature("SIRES"),
    },
    {
      caption: farmer ? "Farm settings" : "Business settings",
      path: `${SETTINGS}${BUSINESS_SETTINGS}`,
      visible: isAdmin,
    },
    {
      caption: "User management",
      path: `${SETTINGS}${MANAGEMENT_SETTINGS}`,
      visible: isAdmin,
    },
    {
      caption: "Supplier Management",
      path: SUPPLIER_MANAGEMENT,
      visible: isAdmin && useHasFeature("SUPPLIER_MANAGEMENT"),
    },
    {
      caption: "Address book",
      path: `${SETTINGS}${ADDRESS_BOOK}`,
      visible: useHasFeature("SHOW_ADDRESS_BOOK"),
    },
    {
      caption: "Bank details",
      path: `${SETTINGS}${BANK_DETAILS}`,
      visible: (isAdmin || isManager) && useHasFeature("BANK_DETAILS"),
    },
    {
      caption: "Subscription details",
      path: `${SETTINGS}/subscription`,
      visible: isAdmin && useHasFeature("SHOW_PAYWALL"),
    },
  ];

  useEffect(() => {
    eventsRequest({ name: "enters-settings" });
  }, []);

  return (
    <PageMenu title="Settings" subtitle={`v${api.version}`}>
      {subMenuItems.map(
        ({ caption, path, visible = true }) =>
          visible && (
            <PageMenuLink caption={caption} id={`${ELEMENTS_IDS.PAGE_MENU_LINK}_${caption}`} key={path} path={path} />
          ),
      )}
    </PageMenu>
  );
};
